import React from 'react';
import { miniCollarId } from '../../../../../../types';
import { FAQItem } from './types';

export const ES_FAQS: FAQItem[] = [
  {
    id: 'works-in-spain',
    titleKey: 'does_fi_work_in_spain',
    answerKey:
      'yes_fi_works_across_spain_with_full_gps_tracking_and_cellular_connectivity_whether_youre_in_the_city_on_a_beach_walk_or_exploring_the_campo_fi_keeps_you_connected_to_your_dog_at_all_times',
  },
  {
    id: 'find-dog-crowded-area',
    titleKey: 'can_fi_help_me_find_my_dog_in_a_crowded_park_or_urban_area',
    answerKey:
      'absolutely_fi_provides_real_time_gps_location_updates_so_you_can_pinpoint_your_dog_the_moment_they_wander_off_whether_thats_a_busy_city_street_a_pipi_can_or_an_open_field_you_can_set_up_custom_safe_zones_and_get_instant_alerts_the_moment_your_dog_leaves_the_area_youve_defined',
  },
  {
    id: 'spanish-support',
    titleKey: 'is_fi_customer_support_available_in_spanish',
    answerKey:
      'yes_our_app_support_team_and_onboarding_materials_are_all_available_in_spanish_fi_is_built_for_dog_owners_wherever_they_are',
  },
  {
    id: 'membership-start',
    titleKey: 'when_does_my_fi_membership_start',
    answerKey: 'your_fi_membership_starts_when_you_activate_your_device_or_7_days_after_the_series_3_is_shipped',
  },
  {
    id: 'why-membership',
    titleKey: 'why_is_fi_a_membership',
    answerContent: (t) => (
      <>
        {t(
          'the_fi_membership_provides_a_lower_cost_way_for_customers_to_try_the_most_advanced_technology_for_their_dogs_without_a_high_upfront_cost_fi_also_believes_in_continuing_to_deliver_new_features_analytics_and_benefits_and_a_membership_model_allows_us_to_continue_investing_in_the_best_possible_customer_experience',
        )}
        <br />
        <br />
        {t(
          'your_membership_includes_unlimited_att_cellular_service_and_gps_access_as_well_as_a_family_plan_so_you_can_share_your_account_with_everyone_who_cares_for_your_dog',
        )}
      </>
    ),
  },
  {
    id: 'lower-monthly-payment',
    titleKey: 'can_i_lower_my_monthly_payment_cost',
    answerContent: (t) => (
      <>
        {t(
          'the_longer_you_commit_to_fi_the_lower_your_monthly_cost_once_you_are_a_member_you_can_always_switch_to_an_annual_membership_to_lock_in_savings_additionally_our_referral_program_gives_you_a_free_month_for_each_person_you_refer',
        )}
      </>
    ),
    showWhen: (context) => !context.freeTrialEnabled,
  },
  {
    id: 'lower-monthly-payment-with-trial',
    titleKey: 'can_i_lower_my_monthly_payment_cost',
    answerContent: (t) => (
      <>
        {t(
          'the_longer_you_commit_to_fi_the_lower_your_monthly_cost_once_you_are_a_member_you_can_always_switch_to_an_annual_membership_to_lock_in_savings_additionally_our_referral_program_gives_you_a_free_month_for_each_person_you_refer',
        )}
        <br />
        <br />
        {t('you_can_also_try_fi_before_becoming_a_member_with_our_free_trial')}
      </>
    ),
    showWhen: (context) => context.freeTrialEnabled === true,
  },
  {
    id: 'free-trial',
    titleKey: 'is_there_a_free_trial_available',
    answerKey: 'free_trial_faq_answer',
    showWhen: (context) => context.freeTrialEnabled === true,
  },
  {
    id: 'multi-pet-offer',
    titleKey: 'how_does_the_multi_pet_offer_work',
    answerKey: 'multi_pet_offer_faq_answer',
    showWhen: (context) => context.enrolledInPositionDiscount,
  },
  {
    id: 'commitment-period',
    titleKey: 'what_is_the_commitment_period_on_the_month_to_month_and_3_month_memberships',
    answerKey:
      'when_you_sign_up_for_fi_you_can_try_it_for_30_days_if_for_any_reason_you_decide_that_fi_is_not_for_you_you_can_return_your_fi_within_the_return_window_otherwise_the_month_to_month_and_3_month_memberships_have_a_minimum_commitment_of_6_months',
    showWhen: (context) => context.collarId === miniCollarId,
  },
  {
    id: 'existing-member-device',
    titleKey: 'can_i_get_a_new_device_if_im_already_a_fi_member',
    answerKey: 'can_i_get_a_new_device_if_im_already_a_fi_member_answer',
  },
  {
    id: 'new-hardware',
    titleKey: 'what_happens_when_a_new_generation_of_hardware_is_released',
    answerKey:
      'when_you_have_an_active_fi_membership_you_dont_have_to_worry_about_having_outdated_hardware_you_are_eligible_to_upgrade_to_the_latest_hardware_at_a_discounted_price',
  },
];
